// extracted by mini-css-extract-plugin
module.exports = {"root":"PackageQuantityBadges_root__z3xog"};